var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.3306 6.00077C32.1943 5.98672 32.0569 5.98672 31.9206 6.00077H3.92062C3.74117 6.00353 3.5629 6.03044 3.39062 6.08077L17.8406 20.4708L32.3306 6.00077Z",
    fill: "#58B461"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8097 7.39062L19.2497 21.8906C18.875 22.2631 18.3681 22.4722 17.8397 22.4722C17.3113 22.4722 16.8044 22.2631 16.4297 21.8906L1.99969 7.50063C1.95533 7.66367 1.93181 7.83167 1.92969 8.00063V28.0006C1.92969 28.5311 2.1404 29.0398 2.51547 29.4148C2.89055 29.7899 3.39925 30.0006 3.92969 30.0006H31.9297C32.4601 30.0006 32.9688 29.7899 33.3439 29.4148C33.719 29.0398 33.9297 28.5311 33.9297 28.0006V8.00063C33.9217 7.79228 33.8812 7.58646 33.8097 7.39062V7.39062ZM5.29969 28.0006H3.90969V26.5706L11.1797 19.3606L12.5897 20.7706L5.29969 28.0006ZM31.9097 28.0006H30.5097L23.2197 20.7706L24.6297 19.3606L31.8997 26.5706L31.9097 28.0006Z",
    fill: "#58B461"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgEmail);
export default __webpack_public_path__ + "static/media/img_email.7808536530fefbbf817e08e5dd7c216f.svg";
export { ForwardRef as ReactComponent };